// extracted by mini-css-extract-plugin
export var subtitle = "_c1-2";
export var title = "_c1-0";
export var titleNoWrap = "_c1-1";